<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b>CSE-IT</b>
          <router-link v-if="isCseitTrained && isAllowedToCreateOrEditPerson" :to="'/cseit/' + friendlyPersonId + '/add'">
            <b-button type="button" variant="outline-primary" size="sm" class="float-right">
              <span class="button-text">Add CSE-IT</span>
            </b-button>
          </router-link>
          <b-button v-if="!isAllowedToCreateOrEditPerson" disabled type="button" variant="outline-primary" size="sm" class="float-right">
            <span class="button-text">Add CSE-IT</span>
          </b-button>
      </b-card-header>
      <div v-if="cseits.length > 0">
        <b-list-group v-for="cseit in cseits" :key="cseit.id" flush>
          <b-list-group-item>
            <router-link :to="{ path: `/cseit/${cseit.id}/view/score`, query: { id: cseit._id } }">
                {{ $moment(cseit.createdAt).format('MM/DD/YYYY') }} {{cseit.id}}
                <img
                  class="cseit-icon"
                  v-if="cseit.calc_cseitScore == 'Possible Concern'"
                  :src="'/static/img/ConcernPossible.png'"
                  height="21"
                  width="21"
                >
                <img
                  class="cseit-icon"
                  v-if="cseit.calc_cseitScore == 'Clear Concern'"
                  :src="'/static/img/ConcernDanger.png'"
                  height="21"
                  width="21"
                >
                <img
                  v-if="cseitIsShared(cseit)"
                  :src="'/static/img/shareYes.png'"
                  height="21"
                  width="21"
                >
            </router-link>
          </b-list-group-item>
        </b-list-group>
        <router-link :to="'/person/' + friendlyPersonId + '/edit?tabIndex=1'" v-if="isAllowedToCreateOrEditPerson">
          <b-button
            type="button"
            variant="danger"
            size="md"
            class="mb-3"
            style="margin-left: 1.25rem;"
          >
            <span class="button-text">Update Victim Status</span>
          </b-button>
        </router-link>
      </div>

      <div v-if="cseits.length === 0">
        <b-list-group flush>
          <b-list-group-item>
            <p>No CSE-IT's</p>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'share-cseit-list',
  props: {
    cseits: Array,
    friendlyPersonId: String,
    userCurrentContext: {
      type: Object,
      default () {
        return {}
      }
    },
    isAllowedToCreateOrEditPerson: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      sharePersonRecords: 'sharePersonRecords'
      // authUserInfo: 'authUserInfo'
    }),

    isCseitTrained () {
      const user = this.$auth.user()
      return user && user.isCseitTrained
    }
  },
  methods: {
    cseitIsShared: function (cseit) {
      return this.sharePersonRecords.length
      // const records = cseit.sharingRecords
      // const hasRecords = !_.isEmpty(records)
      // if (!hasRecords) {
      //   return false
      // }

      // const active = records.filter((cseit) => cseit.cseitShareStatus)
      // return active.length > 0
    }
  }
}
</script>

<style>
  .cseit-icon {
    margin-left: 3px;
    position: relative;
    top: -1px;
  }

  .list-group-item:last-child {
    border-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cseit/ShareCseit.vue